/*!
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';
import Svg from "../../widgets/Svg/Svg";
import moment from 'moment';
import {OFFER_DETAILS} from "../../constants/constants";

export default class OfferDetailsHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false
        };
    }
    render() {
        const {offerType,offerStartDate,offerEndDate,offerStatus} = this.props.offerDetails;
        return (
            <div className={this.state.isVisible ? 'is-visible' : null}>
                <Collapsible
                    trigger={
                        <div className="course-header">
                            <span
                                role="button"
                                aria-expanded={this.state.isVisible}
                            >
                            </span>   
                            <span className="details-span">{`${OFFER_DETAILS.OFFER_TYPE_CODE}: ${offerType.offerTypeCode}`}</span>
                            <span className="details-span">{`${OFFER_DETAILS.OFFER_START_DATE}: ${moment.utc(offerStartDate).format('YYYY-MM-DD')}`}</span>
                            <span className="details-span">{`${OFFER_DETAILS.OFFER_END_DATE}: ${moment.utc(offerEndDate).format('YYYY-MM-DD')}`}</span>
                            <span className="details-span">{`${OFFER_DETAILS.OFFER_STATUS}: ${offerStatus}`}</span>
                        </div>
                        
                    }
                    overflowWhenOpen="visible"
                    tabIndex={0}
                    triggerSibling={() => <span><Svg svgString="bi-chevron-down" /></span>}
                    onOpening={() => this.setState({ isVisible: true })}
                    onClose={() => this.setState({ isVisible: false })}
                >
                    <div>{this.props.children}</div>
                </Collapsible>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OfferDetailsHeader.js